import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectCreateDtoSchema = z.object({
  name: z.string().max(255).nullable().default(null).describe('The name of the project'),
  captchaToken: z.string().optional().describe('The captcha token'),
});

@UseSchema(projectCreateDtoSchema)
export class ProjectCreateDto {}
export interface ProjectCreateDto extends z.input<typeof projectCreateDtoSchema> {}
